import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { MouseEvent, ReactElement, useState } from 'react';
import { Prompt, useHistory } from 'react-router-dom';
import { ICurrentWorkspaceStore } from '../../../../modules/workspaces/currentWorkspace/CurrentWorkspace.store';
import { Home } from '../../../routes/config/Home';
import { IAnnotationsStore } from '../annotations.store';
import { QuitAnnotationsModal } from '../components/QuitAnnotationsModal';
import { IUndoRedoHistory } from '../undoRedoHistory.service';

export const BackToProjectsButtonContainer = observer((): ReactElement => {
  const history = useHistory();
  const historyService = useInjection(IUndoRedoHistory.$);
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
  const annotationsStore = useInjection(IAnnotationsStore.$);

  const { t } = useTranslator();
  const [showModal, setShowModal] = useState(false);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const handleClick = (event: MouseEvent): void => {
    event.preventDefault();
    if (annotationsStore.image === undefined || !historyService.canUndo) {
      void handleConfirm();
    } else {
      setShowModal(true);
      setConfirmedNavigation(false);
    }
  };

  const handleCancel = (): void => {
    setShowModal(false);
  };

  const handleConfirm = async (): Promise<void> => {
    historyService.clearHistory();
    setShowModal(false);
    setConfirmedNavigation(true);
    history.push(Home.Projects.List.All.withParams({ workspaceId: currentWorkspaceStore.currentWorkspace.id }));
    return Promise.resolve();
  };

  const handleBlockedNavigation = (): boolean => {
    if (!confirmedNavigation && historyService.canUndo) {
      setShowModal(true);
      return false;
    }

    return true;
  };

  return (
    <>
      <Button
        color='neutral'
        variant='topbar'
        tabIndex={-1}
        onClick={handleClick}
        startDecorator={<FontAwesomeIcon icon={faArrowLeft} />}
      >
        {t('back')}
      </Button>
      <Prompt
        when={true}
        message={handleBlockedNavigation}
      />
      <QuitAnnotationsModal
        isOpen={showModal}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
      />
    </>
  );
});
